import { render, staticRenderFns } from "./PreferencesFields.vue?vue&type=template&id=395d97f2&scoped=true&"
import script from "./PreferencesFields.vue?vue&type=script&lang=js&"
export * from "./PreferencesFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d97f2",
  null
  
)

export default component.exports